import {randomFromArray} from '../../../helpers/random-from-array.js'
import {getCombatantsWithStatus} from '../../analysis/team-analysis-utilities.js'
import shuffle from 'lodash/shuffle'

export function getCleaningPath(casterModel, teamCombatants=[], enemyCombatants=[], casterActions=[]) {

  //See if we have any valid friends to clean
  const validFriendlyTargets = getCombatantsWithStatus(teamCombatants, ["lag", "memory-leak", "fire"]);
  if (!validFriendlyTargets.length) {
    //console.log('no friendly targets')
    return null
  }

  //Look for solutions for suffering friends
  const targetActionCombo = getCleaningTargetAndAction(validFriendlyTargets, casterModel, casterActions);

  //We don't have anything that can help our suffering friends
  if (!targetActionCombo) {
    return null;
  }


  //Either be single target or whole team target depending on the action's targetType
  const isWholeTeamTarget = targetActionCombo.actionModel.targetType === "ally-team";

  return {
    actionModel: targetActionCombo.actionModel,
    casterModel: casterModel,
    targetModels: isWholeTeamTarget ? teamCombatants : [targetActionCombo.targetModel]
  };

}

/** Search targets for statuses that we can fix. Return a Target paired with an Action that will fix the status */
function getCleaningTargetAndAction(validTargets, casterModel, casterActions) {

  const isCasterInList = validTargets.find(comb => comb.id === casterModel.id);

  let useTargets;
  if (isCasterInList) {
    const teamWithoutCaster = shuffle([...validTargets]).filter(comb => comb.id !== casterModel.id);
    if (casterModel.isSelfServing) {
      useTargets = [
        casterModel,
        ...teamWithoutCaster
      ]
    } else {
      useTargets = [
        ...teamWithoutCaster,
        casterModel
      ]
    }
  } else {
    useTargets = shuffle(validTargets);
  }


  //Loop through each target and check if we have a solution
  for (let index=0; index <= useTargets.length-1; index++) {

    const targetModel = useTargets[index];

    //Do we have something that can fix this status?
    const validActions = casterActions.filter(action => {
      if (!action.affectTargetStatus) {
        return false
      }
      const fromStatus = action.affectTargetStatus[0];
      return (fromStatus === targetModel.status || fromStatus === "*") && action.affectTargetStatus[1] === "normal";
    });

    //TODO: warning: Team Clean comes back with this. Might need to bump that to an "isSuper" flag or something


    if (validActions.length) {
      //End the loop
      return {
        actionModel: randomFromArray(validActions),
        targetModel: targetModel,
      }
    }
  }
  return null;
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/personality-paths/get-cleaning-path.js